// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from 'firebase/app';
// bootstrap
import { ModalPlugin, NavbarPlugin, ButtonPlugin, FormSelectPlugin, FormInputPlugin, FormGroupPlugin, FormTextareaPlugin, FormRadioPlugin, FormCheckboxPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// font-awsome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBackspace, faSave, faPlus, faWrench, faMinus, faFolderPlus, faChartBar, faHistory, faUser, faCopy, faHome, faLink, faEnvelope, faTrashAlt, faList, faExternalLinkAlt, faEdit, faSearch, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from '@/App';
import store from '@/vuex/store';
import router from '@/router';
import firebaseConfig from '../config/firebase.config';

Vue.use(ModalPlugin);
Vue.use(NavbarPlugin);
Vue.use(ButtonPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormCheckboxPlugin);
library.add(faBackspace, faWrench, faSave, faPlus, faMinus, faFolderPlus,
  faChartBar, faHistory, faUser, faTwitter, faCopy, faHome, faEdit, faSearch,
  faGoogle, faLink, faEnvelope, faTrashAlt, faList, faExternalLinkAlt, faFileDownload);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

firebase.initializeApp(firebaseConfig);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js